import React, {Component, useContext} from 'react'
import {Link} from 'react-router-dom'
import logo from '../../../public/images/harnois-logo.svg'

import CurrentMember from '../components/Header/CurrentMember'
import LangSwitcher from '../components/Header/LangSwitcher'
import MemberInfo from '../components/Header/MemberInfo'
import UserContext from '../context/user-context';
import Spinner from '../components/UI/Spinner';
import Alerts from '../components/UI/Alerts/Alerts';
import {withTranslation} from 'react-i18next'
import Auxiliary from "../hoc/Auxiliary";
import FidelityPts from "../components/UI/FidelityPts";
import Notifications from "../components/Header/Notifications";

import {userHaveSpecificPermission} from "../components/Utils/UserHelper";

//const Header = () => (
class Header extends Component {
    static contextType = UserContext;
    containerProfile = React.createRef();

    constructor(props) {
        super(props);
        const {t} = this.props;
        this.state = {
            showProfilMenu: false
        };

    }

    openMenu = () => {
        document.body.classList.toggle('open-menu');
    };
    closeMenu = () => {
        if (document.body.classList.contains('open-menu')) {
            document.body.classList.remove('open-menu');
        }
    };
    openProfileMenu = () => {
        this.setState((prevState) => {
            return {showProfilMenu: !prevState.showProfilMenu};
        })
    };

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = event => {
        if (this.containerProfile.current && !this.containerProfile.current.contains(event.target)) {
            this.setState({
                showProfilMenu: false
            });
        }
    };


    logout = (event) => {
        event.preventDefault();
        document.getElementById('logout-form').submit();
    };

    render() {
        const user = this.context.user;
        let userName = false
        let permission;
        let can_personify;
        let canChangeAccount;
        let hasAccountCode = false;
        let personnificationAccountId = 0;
        if (user.infos) {
            userName = user.infos.firstname;
            permission = user.infos.permission;
            can_personify = user.infos.can_personify;
            canChangeAccount = user.infos.account_count>1;
            hasAccountCode = (user.account && user.account.accountCode);
            personnificationAccountId = user.infos.personnification_account_id;
        }
        const {t} = this.props;
        const logoHtml = <img src={logo} alt={'Harnois ' + t('footer.energy')} title={'Harnois ' + t('footer.energy')}/>;
        return (
            <header className="header">
                <div className="header__upper">
                    <Alerts/>
                    <div className="container container--larger">
                        <div className="flex flex--align-center flex--justify-end">
                            <CurrentMember/>
                        </div>
                    </div>
                </div>
                <div className="header__topbar">
                    <div className="container container--larger flex flex--justify-end">
                        <nav id="topbar-menu">
                            <ul>
                                <li>
                                    <Link  to={"/faq"} onClick={this.closeMenu}>
                                        {t('header.need_help')}
                                    </Link>
                                </li>
                                <li>
                                    <a target="_blank" href={t('header.our_products_link')} onClick={this.closeMenu}>
                                        {t('header.our_products')}
                                    </a>
                                </li>
                                {!personnificationAccountId &&
                                    <li className={`profile-menu ${this.state.showProfilMenu ? "open-menu-profile" : ""}`}
                                        ref={this.containerProfile}>
                                        <a onClick={() => this.openProfileMenu()} className={`profile-menu-trigger`}>
                                            {t('header.welcome_message', {username: userName || ""})}&nbsp;&nbsp;&nbsp;<i
                                            className='fal fa-angle-down'></i></a>
                                        <ul className="sub-menu">
                                            <li className="member-info">
                                                <MemberInfo/>
                                            </li>
                                            <li>
                                                <a className="" onClick={this.logout} href="/logout">
                                                  {t('header.logout')}
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                }
                                {
                                    user.account && user.account.proxiCardNumber !== "" && <li className="fidelity-menu">
                                        <FidelityPts account={user.account} />
                                    </li>
                                }

                            </ul>

                        </nav>
                        {user.account && user.account.length !== 0 && <Notifications
                            loadingNotifs={this.props.loadingNotifs}
                            notificationMessages={this.props.notificationMessages}
                        />}
                        <LangSwitcher/>
                    </div>
                </div>
                <div className="header__mainbar">
                    <div className="container container--larger flex flex--align-center posrel">

                        <div className={`menu-trigger`}
                             onClick={this.openMenu}>
                            <span className="menu-trigger__open"><i className="far fa-bars"></i></span>
                            <span className="menu-trigger__close"><i className="far fa-times"></i></span>
                        </div>

                        {hasAccountCode?<Link to='/' className="site-logo">{logoHtml}</Link>:<Link to='#' className="site-logo">{logoHtml}</Link>}

                            <div className="mobile-memberprofil">
                                <small>{t('header.welcome_message')}</small>
                                <MemberInfo/>
                            </div>
                        <div className="mobile-memberprofil-btns">
                            {hasAccountCode?(
                                <Auxiliary>
                                    {canChangeAccount?
                                        <Link className={"link link--accent link--red"} to="/accounts/change-account" onClick={this.closeMenu}>
                                            {t("header.changeaccount")}
                                        </Link>
                                        :null}
                                    <Link className={"link link--accent  link--black"} to="/accounts/change-account/add" onClick={this.closeMenu}>{t("header.addaccount")}</Link>
                                </Auxiliary>
                            ):null}
                            <Link className='link link--red logout text-uppercase' to='/products'
                                  onClick={this.logout}><strong><i className="fa fa-times"></i>&nbsp;&nbsp;{t('header.logout')}</strong>
                            </Link>
                        </div>
                        {hasAccountCode?(
                            <Auxiliary>
                                <nav id='main-menu' className="main-menu">
                                    <ul>
                                        {permission == 'complete'?
                                            (<li><Link className='' to='/documents'
                                                  onClick={this.closeMenu}>{t('header.navigation.communications')}</Link></li>)
                                            :null}
                                        <li><Link className='' to='/accounts'
                                                  onClick={this.closeMenu}>{t('header.navigation.accounts')}</Link></li>
                                        {permission == 'complete' && userHaveSpecificPermission(user, 'financial_data') ?
                                            (<li><Link className='' to='/invoices'
                                                          onClick={this.closeMenu}>{t('header.navigation.docs')}</Link></li>)
                                            :null}
                                        {!personnificationAccountId && <li><Link className='' to='/profile'
                                                  onClick={this.closeMenu}>{t('header.navigation.profile')}</Link></li>}
                                        {((user.paymentAllowed && userHaveSpecificPermission(user, 'financial_data')) || can_personify) && <li className="main-menu__btns">
                                            { user.paymentAllowed &&
                                            <Link
                                                className='link link--red link--hover--black'
                                                to={{pathname:'/payment',
                                                    state: {by: "fix", selection : null}
                                                }}
                                                onClick={this.closeMenu}>
                                                <i className="fas fa-file-invoice-dollar"></i>&nbsp;&nbsp;{t('header.navigation.payment')}
                                            </Link>
                                            }
                                            {can_personify ?
                                                (<Link
                                                    className='btn btn--raised--red btn--raised' to='/personnification'
                                                    onClick={this.closeMenu}>{t('header.navigation.personnification')}</Link>
                                                )
                                                : null}
                                        </li>}

                                    </ul>
                                </nav>
                            </Auxiliary>
                        ):<Auxiliary>
                            <nav id='main-menu'>
                                <ul>
                                    {can_personify?
                                        (<li><Link className='btn btn--raised--red btn--raised' to='/personnification'
                                                   onClick={this.closeMenu}>{t('header.navigation.personnification')}</Link></li>)
                                        :null}
                                </ul>
                            </nav>
                        </Auxiliary>}
                    </div>
                </div>
                <form id="logout-form" action="/logout" method="POST"  style={{display: "none"}}>
                    <input type="hidden" name="_token" value={document.head.querySelector('meta[name="csrf-token"]').content}/>
                </form>
            </header>
        );
    }
}

export default withTranslation()(Header);
